import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MentionMeWrapperComponentDef } from '@df/module-mention-me/mention-me-wrapper.component.def';
@Component({
    selector: 'mention-me-wrapper',
    template: `<div id="mmWrapper"></div>`,
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MentionMeWrapperComponent extends MentionMeWrapperComponentDef {}
